import React from 'react';
import PropTypes from 'prop-types';

import { isBrowser, getWindowTotalHeight } from 'Helpers/Browser';

export default class LazyLoadContainer extends React.PureComponent {
    static propTypes = {
        children: PropTypes.any,
        onOffsetChange: PropTypes.func.isRequired,
        baseOffset: PropTypes.number.isRequired
    };
    static defaultProps = {
        baseOffset: 200
    };

    _isMounted = false;
    lazyLoadPreloadStateInterval = null;
    userScrollTimeout = null;

    constructor(props) {
        super(props);

        this.state = {
            offset: 100,
            allImagesLoaded: false
        };
    }

    componentDidMount = () => {
        this._isMounted = true;
        window.addEventListener('scroll', this.resetLazyLoadOffset);
        this.resetLazyLoadOffset();
    }

    componentWillUnmount = () => {
        this._isMounted = false;
        window.removeEventListener('scroll', this.resetLazyLoadOffset);
    }

    componentWillReceiveProps = nextProps => {
        this.setState({
            ...this.state,
            allImagesLoaded: false
        }, this.resetLazyLoadOffset);
    }

    resetLazyLoadOffset = () => {
        if (!isBrowser()) {
            return false;
        }

        //Break if wrapper isnt set
        if (!this.refs.wrapper) {
            return false;
        }

        //Break if all images has been loaded
        if (this.state.allImagesLoaded) {
            return false;
        }

        this.setState({
            ...this.state,
            offset: this.props.baseOffset
        }, () => {
            clearTimeout(this.userScrollTimeout);
            this.userScrollTimeout = setTimeout(() => {
                this.preloadLazyLoadImages();
            }, 500);
        });
    }

    preloadLazyLoadImages = () => {
        const { wrapper } = this.refs;
        clearInterval(this.lazyLoadPreloadStateInterval);

        this.lazyLoadPreloadStateInterval = setInterval(() => {
            if (!this._isMounted) {
                clearInterval(this.lazyLoadPreloadStateInterval);
                return false;
            }

            //Check if some photos are still not loaded
            let allImagesReady = true;
            Array.prototype.forEach.call(wrapper.getElementsByTagName('img'), img => {
                //Check if image is visible and has been loaded 
                if (!img.complete && img.offsetParent !== null) {
                    allImagesReady = false;
                }
            });

            if (allImagesReady) {
                //Count only visible placeholders
                let lazyLoadPlaceholdersCount = 0;
                Array.prototype.forEach.call(wrapper.getElementsByClassName('lazyload-placeholder'), placeholder => {
                    lazyLoadPlaceholdersCount = placeholder.offsetParent !== null ? lazyLoadPlaceholdersCount + 1 : lazyLoadPlaceholdersCount;
                });

                if (lazyLoadPlaceholdersCount && this.state.offset < getWindowTotalHeight()) {
                    const newOffset = this.state.offset + this.props.baseOffset;
                    this.props.onOffsetChange(newOffset);

                    this.setState({
                        ...this.state,
                        offset: newOffset
                    });
                } else {
                    clearInterval(this.lazyLoadPreloadStateInterval);
                    this.setState({
                        ...this.state,
                        allImagesLoaded: true
                    });
                }
            }
        }, 250);
    }


    render() {
        return (
            <div className={`component-lazy-load-container`} ref='wrapper'>
                {this.props.children}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/layout/LazyLoadContainer/index.js